export const modal$ = (state) => state.modal;
export const toast$ = (state) => state.toast;
export const currentId$ = (state) => state.currentId;
export const categories$ = (state) => state.categories;
export const warehouses$ = (state) => state.warehouses;
export const suppliers$ = (state) => state.suppliers;
export const products$ = (state) => state.products;
export const customers$ = (state) => state.customers;
export const comments$ = (state) => state.comments;
export const orders$ = (state) => state.orders;
export const admins$ = (state) => state.admins;
